import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import styles from './styles';

const DownloadReportButton = ({
  classes, selectedCurrency, selectedDate, title,
}) => {
  if (!selectedCurrency || !selectedDate) {
    console.warn('DownloadReportButton: Missing required props', {
      selectedCurrency,
      selectedDate,
    });
    return null; // Do not render if required props are missing
  }

  const href = encodeURI(`https://pricelist.qlik.com/jwt/content/Reports/${title}${selectedCurrency}${selectedDate}.pdf`).replace(/%20/g, '+');

  return (
    <div>
      <a href={href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
        <button className={classes.button}>Request report</button>
      </a>
    </div>
  );
};

DownloadReportButton.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  selectedCurrency: PropTypes.string.isRequired,
  selectedDate: PropTypes.string.isRequired,
};

export default injectSheet(styles)(DownloadReportButton);
